// extracted by mini-css-extract-plugin
export var aiStarSpin = "_qt-1";
export var spinner = "_qt-0";